import React from 'react';
import { Icon } from '@iconify/react';

export const WritingModelVisual = () => {
  return (
    <div className="w-[90%] h-[85%] bg-white rounded-xl shadow-lg border border-gray-100 flex overflow-hidden relative">

        {/* Sidebar */}
        <div className="w-1/3 bg-gray-50 border-r border-gray-100 p-3 flex flex-col gap-3">
            <div className="text-[9px] font-bold text-gray-400 uppercase tracking-wider mb-1">Toolbox</div>

            <div className="bg-white p-2 rounded-lg shadow-sm border border-gray-100 flex items-center gap-2 cursor-pointer hover:bg-purple-50 transition-colors group">
                <div className="w-5 h-5 rounded-full bg-yellow-100 flex items-center justify-center text-yellow-600 group-hover:scale-110 transition-transform">
                    <Icon icon="mdi:lightbulb" width={10} />
                </div>
                <div className="text-[9px] font-medium text-gray-700">Ideas</div>
            </div>

            <div className="bg-white p-2 rounded-lg shadow-sm border border-gray-100 flex items-center gap-2 cursor-pointer hover:bg-purple-50 transition-colors group">
                <div className="w-5 h-5 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 group-hover:scale-110 transition-transform">
                    <Icon icon="mdi:key" width={10} />
                </div>
                <div className="text-[9px] font-medium text-gray-700">Keywords</div>
            </div>

            <div className="bg-white p-2 rounded-lg shadow-sm border border-gray-100 flex items-center gap-2 cursor-pointer hover:bg-purple-50 transition-colors group">
                <div className="w-5 h-5 rounded-full bg-pink-100 flex items-center justify-center text-pink-600 group-hover:scale-110 transition-transform">
                    <Icon icon="mdi:dice-multiple" width={10} />
                </div>
                <div className="text-[9px] font-medium text-gray-700">Random</div>
            </div>
        </div>

        {/* Main Editor */}
        <div className="flex-1 p-4 relative">
             <div className="flex items-center justify-between mb-3">
                <div className="text-[10px] font-bold text-gray-800">New Article Draft...</div>
                <div className="flex items-center gap-1 bg-purple-100 text-purple-700 px-1.5 py-0.5 rounded text-[8px] font-bold">
                    <Icon icon="mdi:auto-fix" width={8} /> AI Writing
                </div>
             </div>

             <div className="space-y-2">
                 <div className="h-2 w-3/4 bg-gray-100 rounded"></div>
                 <div className="h-2 w-full bg-gray-100 rounded"></div>
                 <div className="h-2 w-5/6 bg-gray-100 rounded"></div>
                 <div className="flex items-center gap-1">
                    <div className="h-2 w-1/2 bg-gray-100 rounded"></div>
                    <div className="w-0.5 h-3 bg-purple-500 animate-pulse"></div>
                 </div>
             </div>

             {/* Floating AI Suggestion */}
             <div className="absolute bottom-4 right-4 bg-white shadow-xl border border-purple-100 rounded-lg p-2 max-w-[120px] transform rotate-[-2deg]">
                 <div className="text-[8px] text-gray-400 mb-1">AI Suggestion:</div>
                 <div className="text-[9px] font-medium text-purple-600 leading-tight">
                    "Try adding more emotion to increase resonance..."
                 </div>
             </div>
        </div>
    </div>
  );
};

export default WritingModelVisual;
